import { takeAddToCartSaga } from "./takeAddToCart";

export const sagas = [takeAddToCartSaga];
